import type { Theme } from "@mui/material/styles";
// Canvas needs resolved colors, never generated CSS references.
export const getChartTextColor = (theme: Theme): string =>
  theme.palette.text.secondary;
